<template lang="pug">
  lei-modal.challenge-modal(@close="toggleModal(false)" title="Challenge: LEI Code" size="sm")
    .container
      input-creator(
        label="Uniqueness"
        :value="uniqueness"
        @set-input-value="({value}) => setInputValue(value, 'uniqueness')")
    .container
      p.description {{description}}
    .container
      input-creator(
        label="Exclusivity"
        :value="exclusivity"
        @set-input-value="({value}) => setInputValue(value, 'exclusivity')")
    .container
      p.description Please enter the LEI code of the other LEI registration for this legal entity.
    .container
      el-input.lei-input(
        v-model="comment"
        type="textarea"
        placeholder="Add comment"
        :autosize="{minRows: 4, maxRows: 7}")
    div(slot="footer")
      lei-btn(type="cyprus" fill @click="save") Save
</template>
<script>
import { mapState, mapMutations, } from 'vuex'
import { TOGGLE_CHALLENGE_LEI_CODE_MODAL, } from '../../store/modules/record/modules/challenge/mutations-types'
import InputCreator from '../lei-components/inputs/InputCreator'
import LeiModal from '../lei-components/LeiModal'
import LeiBtn from '../lei-components/LeiBtn'
// import {EventBus} from '../../event-bus'

export default {
  components: {
    LeiBtn,
    LeiModal,
    InputCreator,
  },
  data () {
    return {
      description: 'Please enter the legal name (tha officially registered name) ' +
        'for the legal entity that you believe shares the same LEI code as this one.',
      comment: '',
      uniqueness: '',
      exclusivity: '',
    }
  },
  computed: {
    ...mapState('record/challenge', [ 'challenge', ]),
    ...mapState('search', [ 'filters', ]),
  },
  methods: {
    save () {
      this.$emit('save', { comment: this.comment, })
      this.toggleModal(false)
    },
    setInputValue (value, field) {
      this[field] = value
    },

    ...mapMutations('record/challenge', {
      toggleModal: TOGGLE_CHALLENGE_LEI_CODE_MODAL,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal
    &.modal
      z-index 102

    .description
      text-align justify
      color $default-color
      line-height 1.25

  @media (min-width: $laptop)
    .challenge-modal
      .container
        margin-bottom 25px

        &:last-child
          margin-bottom 0

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengeLeiCodeModal.vue